import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  StyledBoxGeneric,
  StyledBoxDown,
  StyledButton,
  StyledLabel,
  StyledBoxInput
} from './style';

import Input from '../../../core/Input';
import Modal from '../../../core/Modal';
import { RRSS } from '../../../../constants/literals/modals';

import { firstCapitalLetter } from '../../../../utils/strings';

class Social extends Component {
  constructor(props) {
    super(props);

    const data = {
      facebook: '',
      twitter: '',
      linkedin: '',
      instagram: '',
      vimeo: '',
      ...props.dataSocial
    };

    this.state = {
      data,
      btnIsDisabled: true
    };
  }

  handleAccept = () => {
    const { onAcceptModal } = this.props;
    let { data } = this.state;

    data = Object.keys(data).reduce((acc, key) => {
      if (data[key]) {
        acc[`${key}`] = data[key];
      }
      return acc;
    }, {});

    onAcceptModal(data);
  };

  handleChange = (value, ev) => {
    const { dataSocial } = this.props;
    const { data } = this.state;
    const dataRes = { ...data, [ev.target.name]: value };
    const updateBtnStatus = _.isEqual(dataSocial, dataRes);

    this.setState({ data: dataRes, btnIsDisabled: updateBtnStatus });
  };

  render() {
    const { onCloseModal } = this.props;
    const { data, btnIsDisabled } = this.state;
    return (
      <Modal title={RRSS.TITLE} clickCloseIcon={onCloseModal}>
        <StyledBoxGeneric>
          {Object.keys(data).map(key => (
            <StyledBoxInput key={`${key}`}>
              <StyledLabel>{firstCapitalLetter(key)}</StyledLabel>
              <Input
                name={`${key}`}
                value={data[key]}
                onChange={this.handleChange}
              />
            </StyledBoxInput>
          ))}
          <StyledBoxDown>
            <StyledButton onClick={onCloseModal} modal>
              {RRSS.CANCEL}
            </StyledButton>
            <StyledButton
              onClick={this.handleAccept}
              secondary
              disabled={btnIsDisabled}
            >
              {RRSS.ACCEPT}
            </StyledButton>
          </StyledBoxDown>
        </StyledBoxGeneric>
      </Modal>
    );
  }
}

Social.propTypes = {
  onAcceptModal: PropTypes.func,
  onCloseModal: PropTypes.func,
  dataSocial: PropTypes.shape({
    facebook: PropTypes.string,
    twitter: PropTypes.string,
    vimeo: PropTypes.string,
    instagram: PropTypes.string,
    linkedin: PropTypes.string
  })
};

Social.defaultProps = {
  dataSocial: {}
};

export default Social;
